import { useRef, type ReactNode } from 'react'

interface Props {
  expanded: boolean
  children: ReactNode
}

const Collapse = ({ expanded, children }: Props) => {
  const contentRef = useRef<HTMLDivElement>(null)

  const height = expanded && contentRef.current ? contentRef.current.scrollHeight : 0

  return (
    <div
      ref={contentRef}
      className="overflow-hidden transition-[max-height] duration-200 ease-in-out"
      style={{ maxHeight: height > 0 ? height + 2 : 0 }}
    >
      {children}
    </div>
  )
}

export default Collapse
